export default "__VITE_PUBLIC_ASSET__dc15a9b3__"